//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { tidalSelect } from '@tidal/styles-form';
import tidalButton from '@tidal/styles-button';
import { tidalAmplitude } from '@tidal/tracking';
import productDescription from './productDescription.vue';
import { productBox } from '@tidal/microservice-components';
import customSelectInput from './customSelectInput.component.vue';
import { tidalSwitch } from '@tidal/styles-form';
import {
    getTranslationForSubscriptionType,
    getTranslationForSubscriptionPlan,
    isSameSubscriptionType,
} from '../../api/utils/subscription.util';
import getUserErrorMessage from '~/utils/getErrorMessage';

export default {
    components: {
        tidalButton,
        tidalSelect,
        productDescription,
        productBox,
        customSelectInput,
        tidalSwitch,
    },
    filters: {
        /**
         * @param {string} value
         * @returns {string}
         */
        decimalFilter(value) {
            value = value ? value.toString() : '';

            if (value && value.includes('.')) {
                return parseFloat(value).toFixed(2);
            }
            return value;
        },
    },
    props: {
        /** @type {import('vue').PropOptions<OfferWeb.SubscriptionProduct>} */
        product: {
            type: Object,
            default: () => null,
        },
        user: {
            type: Object,
            default: () => { },
        },
        currentModifier: {
            type: String,
            default: '',
        },
        /** @type {import('vue').PropOptions<Record<string, any>>} */
        lang: {
            type: [Object, Function],
            default: () => { },
        },
        appMode: {
            type: [Object, Boolean],
            default: () => null,
        },
        productName: {
            type: String,
            default: null,
        },
        /** @type {import('vue').PropOptions<Array<OfferWeb.PrepaidPrices> | null>} */
        prepaidPrices: {
            type: Array,
            default: null,
        },
        useGroupedProducts: {
            type: Boolean,
            default: false,
        },
        enableThirdTier: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            /** @type {OfferWeb.LangFeature | null} */
            openedFeature: null,
            periodPlans: {},
            /** @type {Array<{name: string, value: number}>} */
            selectBoxPlans: [],
            /** @type {OfferWeb.GroupedProduct | null} */
            selectedGroupedProduct: null,
            /** @type {OfferWeb.PrepaidPrices | null | undefined} */
            prepaidPlanPicked: null,
            isTeaserOfferSelected: false,
        };
    },
    computed: {
        /** @returns {number | null} */
        highlightElementPosition() {
            const trialDays = this.selectedGroupedProduct ?
                this.selectedGroupedProduct.trialDays : this.product.trialDays;

            if (this.isClient || trialDays === 0 || this.product.type === 'TIDAL_CAMPAIGN') {
                return null;
            }

            return this.featuresCopy.subscriptionTypeFeatures.length - 1;
        },
        /** @return {string | null} */
        productDescription() {
            if (this.isGroupedProduct && this.selectedGroupedProduct
                && this.selectedGroupedProduct.trialDays > 0
                && !this.selectedGroupedProduct.recurring) {
                return this.lang.offer.enjoyForFree.replace('%s', this.selectedGroupedProduct.trialDays);
            } else if (this.product.description && this.product.type === 'TIDAL_CAMPAIGN') {
                return this.product.description;
            }
            return null;
        },
        /** @returns {boolean} */
        isClient() {
            return !!this.appMode;
        },
        /** @returns {boolean} */
        isSelected() {
            return this.currentModifier === this.product.subscriptionPlan;
        },
        /** @returns {boolean} */
        hasPrice() {
            return (!!this.product.price && this.product.price !== 0)
                || (this.product.type === 'TIDAL_CAMPAIGN'
                    && !!this.product.campaignPriceInCents);
        },
        /** @returns {boolean} */
        isGroupedProduct() {
            return this.useGroupedProducts
                && !!this.product.grouped
                && Array.isArray(this.product.grouped);
        },
        /** @returns {boolean} */
        hasContinueListener() {
            return !!(this.$listeners && this.$listeners.continue);
        },
        /** @returns {OfferWeb.FeaturesCopy} */
        featuresCopy() {
            const trialDaysSummaryRegex = /(\{dd\}|[0-9]+)/;
            /** @type {Array<OfferWeb.LangFeature>} */
            const subscriptionPlanFeatures = this.lang.offers.plans[this.getTranslationPlan(this.product.subscriptionPlan)]
                .features;
            /** @type {Array<OfferWeb.LangFeature>} */
            let subscriptionTypeFeatures = this.lang.offers.types[this.getTranslationType(this.product.subscriptionType)]
                .featuresv2;
            const trialDays = this.selectedGroupedProduct ?
                this.selectedGroupedProduct.trialDays : this.product.trialDays;

            if (trialDays === 0 || this.product.type === 'TIDAL_CAMPAIGN') {
                this.$emit('hide-trial-extra-text', true);

                subscriptionTypeFeatures = subscriptionTypeFeatures
                    .filter(feature => feature.summary && !(feature.summary.includes('.*')
                        && trialDaysSummaryRegex.test(feature.summary)));
            } else if (trialDays && trialDays > 0) {
                subscriptionTypeFeatures = subscriptionTypeFeatures.map(feature => {
                    if (feature.summary && feature.summary.includes('.*')
                        && trialDaysSummaryRegex.test(feature.summary)) {
                        return {
                            ...feature,
                            summary: feature.summary.replace(trialDaysSummaryRegex, String(trialDays)),
                        };
                    }
                    return feature;
                });
            }

            return {
                subscriptionTypeFeatures,
                ...subscriptionPlanFeatures && { subscriptionPlanFeatures },
            };
        },
        /** @returns {string} */
        thirdTierButtonStyle() {
            if (this.enableThirdTier) {
                switch (this.product.subscriptionType) {
                    case 'PREMIUM':
                        return 'button-premium';
                    case 'PREMIUM_MID':
                        return 'button-premium-mid';
                    case 'HIFI':
                    case 'PREMIUM_PLUS':
                        return 'button-premium-plus';
                }
            }
            return '';
        },
        /** @returns {string | null} */
        thirdTierFreeTrialDisclaimer() {
            if (this.enableThirdTier && this.featuresCopy.subscriptionTypeFeatures.length) {
                return this.featuresCopy.subscriptionTypeFeatures[this.featuresCopy.subscriptionTypeFeatures.length - 1].summary;
            }
            return null;
        },
    },
    mounted() {
        this.loading = false;

        if (this.isGroupedProduct) {
            this.selectedGroupedProduct = this.product && this.product.grouped
                ? this.product.grouped[0] : null;

            for (const groupedProduct of this.product.grouped || []) {
                this.selectBoxPlans.push({
                    name: this.getPeriodLengthSelectName(groupedProduct),
                    value: groupedProduct.id,
                });
            }
        }
    },
    beforeDestroy() {
        this.loading = false;
    },
    methods: {
        /**
         * @param {UserWebApi.SubscriptionType} type
         * @returns {string}
         */
        getTranslationType(type) {
            return getTranslationForSubscriptionType(type, this.enableThirdTier);
        },
        /**
         * @param {UserWebApi.SubscriptionPlan} plan
         * @returns {string}
         */
        getTranslationPlan(plan) {
            return getTranslationForSubscriptionPlan(plan, this.enableThirdTier);
        },
        async checkAndCreateOrder() {
            if (this.hasContinueListener) {
                this.$emit('continue');
                return;
            }

            if (this.isTeaserOfferSelected && this.product.teaserOfferCampaignId) {
                this.loading = true;

                window.location.href = `/campaigns/${
                    this.product.teaserOfferCampaignId}/rememberLogin?keepSignupParams=true&appMode=${
                    this.appMode ? this.appMode.type : ''}`;
                return;
            }

            await this.createOrder();
        },
        /** @param {string} [campaignId] */
        selectTeaserOffer(campaignId) {
            this.$emit('teaser-offer-selected', campaignId || null);
        },
        /**
         * @param {OfferWeb.SubscriptionProduct} product
         * @returns {string}
         */
        getFormattedPrice(product) {
            const formattedPriceWithPeriod = `${this.getPrice(product)} / ${
                this.getDuration(product)}`;

            if (product.campaignType === 'FREE') {
                return this.getPrice(product);
            }
            if (product.isIncluded) {
                return this.lang.offer.included;
            }

            return product.addPlusToPrice ? `+ ${formattedPriceWithPeriod}`
                : formattedPriceWithPeriod;
        },
        /**
         * @param {OfferWeb.GroupedProduct | OfferWeb.SubscriptionProduct} groupedProduct
         * @returns {boolean}
         */
        getDuration(groupedProduct) {
            return this.lang.planPeriodLength.planTypeDuration[groupedProduct.periodLength];
        },
        /**
         * @param {OfferWeb.GroupedProduct} groupedProduct
         * @returns {string}
         */
        getPeriodLengthName(groupedProduct) {
            return this.lang.planPeriodLength.planTypeNames[groupedProduct.periodLength];
        },
        /**
         * @param {OfferWeb.GroupedProduct} groupedProduct
         * @returns {string}
         */
        getPeriodLengthSelectName(groupedProduct) {
            const periodLengthName = this.getPeriodLengthName(groupedProduct);
            return groupedProduct.dataIncluded
                ? `${periodLengthName} ${this.lang.partner.dataIncluded}`
                : periodLengthName;
        },
        /**
         * @param {OfferWeb.SubscriptionProduct} product
         * @returns {string}
         */
        getProductSummary(product) {
            return this.lang.offers.plans[this.getTranslationPlan(product.subscriptionPlan)].summary || '';
        },
        /**
         * @param {OfferWeb.SubscriptionProduct} product
         * @returns {string}
         */
        getProductName(product) {
            if (this.productName) {
                return this.productName;
            }

            return this.lang.offers.plans[this.getTranslationPlan(product.subscriptionPlan)].name;
        },
        /**
         * @param {OfferWeb.SubscriptionProduct} product
         * @returns {string}
         */
        getPrice(product) {
            if (product.type === 'TIDAL_CAMPAIGN') {
                return product.campaignPriceFormatted;
            }
            return product.priceFormatted;
        },
        /** @param {UserWebApi.SubscriptionPlan} subscriptionPlan */
        selectModifier(subscriptionPlan) {
            this.$emit('product-selected', subscriptionPlan);
        },
        /**
         * @param {OfferWeb.SubscriptionProduct} product
         * @param {number} userId
         */
        async createOrder() {
            this.$emit('hide-error');
            this.loading = true;
            const order = {
                userId: this.user ? this.user.id : undefined,
                product: this.product,
                selectedGroupedProduct: this.selectedGroupedProduct,
                prepaidPlanPicked: this.prepaidPlanPicked,
                enableThirdTier: this.enableThirdTier,
            };

            if (tidalAmplitude.getDeviceId()) {
                Object.assign(order, { amplitudeDeviceId: tidalAmplitude.getDeviceId() });
            }

            let response;
            try {
                response = await this.$axios.post('/api/order/create', order);
            } catch (error) {
                /** @type {import('axios').AxiosError<import('@tidal/user-models').ClientApiError>} */
                const apiError = error;

                this.$emit('error', {
                    error: {
                        message: getUserErrorMessage(this.lang, apiError.response?.data.messageCode),
                    },
                    isNetworkError: error.message === 'Network Error',
                });
                return;
            } finally {
                this.loading = false;
            }

            this.$emit('success', response.data);
        },
        /** @param {OfferWeb.LangFeature | null} feature */
        openFeature(feature) {
            if (this.openedFeature === feature) {
                this.openedFeature = null;
            } else {
                this.openedFeature = feature;
            }
        },
        /** @param {{value: string}} selected */
        periodSelected(selected) {
            const id = Number(selected.value);
            // set the picked period options
            this.selectedGroupedProduct = this.product && this.product.grouped
                ? this.product.grouped.find(groupedPr => groupedPr.id === id) || null : null;
        },
        /**
         * @param {UserWebApi.SubscriptionType} subscriptionType
         * @param {UserWebApi.SubscriptionPlan} subscriptionPlan
         */
        getPrepaidPricesForPlanAndType(subscriptionType, subscriptionPlan) {
            if (this.prepaidPrices && this.prepaidPrices.length > 0) {
                return this.prepaidPrices
                    .filter(prepaidPrice => isSameSubscriptionType(prepaidPrice.subscriptionType, subscriptionType)
                        && prepaidPrice.subscriptionPlan === subscriptionPlan)
                    .map(prepaidPrice => {
                        const prepaidObject = {
                            text: `<strong class='font-weight-bold'>${
                                this._getCustomSelectBoxDuration(prepaidPrice.prepaidLength)
                            }</strong> - <span class='opacity-60'>${prepaidPrice.formatted}</span>`,
                            value: prepaidPrice.prepaidLength,
                            defaultSelected: prepaidPrice.defaultSelected,
                            price: prepaidPrice.price,
                        };
                        if (prepaidPrice.discountPercentage) {
                            prepaidObject.text += ` <span class='primary'>(-${prepaidPrice.discountPercentage}%)</span>`;
                        }
                        return prepaidObject;
                    }).sort((a, b) => Number(a.price) - Number(b.price));
            }
            return [];
        },
        /**
         * @param {UserWebApi.SubscriptionType} subscriptionType
         * @param {UserWebApi.SubscriptionPlan} subscriptionPlan
         * @return {{ text: string; value: UserWebApi.PeriodLengthPrepaid; defaultSelected: boolean; price: number; } | undefined}
         */
        getDefaultPrepaidPrice(subscriptionType, subscriptionPlan) {
            this.prepaidPlanPicked = this.prepaidPrices && this.prepaidPrices.find(prepaidPrice => prepaidPrice.defaultSelected
                && isSameSubscriptionType(prepaidPrice.subscriptionType, subscriptionType) && prepaidPrice.subscriptionPlan === subscriptionPlan);
            return this.getPrepaidPricesForPlanAndType(subscriptionType, subscriptionPlan)
                .find(priceObj => priceObj.defaultSelected);
        },
        /** @param {{value: string}} duration */
        durationSelected(duration) {
            this.prepaidPlanPicked = this.prepaidPrices && this.prepaidPrices.find(prepaidPrice => {
                return prepaidPrice.prepaidLength === duration.value
                    && prepaidPrice.subscriptionPlan === this.product.subscriptionPlan
                    && isSameSubscriptionType(prepaidPrice.subscriptionType, this.product.subscriptionType);
            });
        },
        /** @param {MouseEvent} event */
        stopPropagation(event) {
            event.stopPropagation();
            event.preventDefault();
        },
        /** @param {UserWebApi.PeriodLengthPrepaid} prepaidLength */
        _getCustomSelectBoxDuration(prepaidLength) {
            if (prepaidLength.startsWith('ONE_')) {
                return `1 ${this.lang.planPeriodLength.planTypeDuration[prepaidLength]}`;
            }
            return this.lang.planPeriodLength.planTypeDuration[prepaidLength];
        },
    },
};
